import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { UserConfigs } from "src/app/models/UserConfigs";
import { UsuarioUnidade } from "src/app/models/usuario-unidade";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UsuarioService {
  Global: any;

  constructor(private httpClient: HttpClient) { }

  efetuarLogin(login: string, senha: string, fingerPrint: string): Promise<any> {
    const dados = {
      login: login,
      senha: senha,
      fp: fingerPrint,
    };
    return this.httpClient
      .post(environment.wsUrl + "cliente/login", dados, {
        params: { ignore: ["401"] },
      })
      .toPromise();
  }

  obterEmailMascarado(login: string): Promise<any> {
    const dados = {
      login: login,
    };
    return this.httpClient
      .post(environment.wsUrl + "cliente/emailRecuperacaoSenha", dados, {
        params: { ignore: ["401"] },
      })
      .toPromise();
  }

  recuperarSenha(email, login) {
    return this.httpClient
      .post(
        environment.wsUrl + "usuario/atualizarSenhaEsquecida",
        { email: email, login: login },
        { params: { ignore: ["401"] } }
      )
      .toPromise();
  }

  listaUsuariosUnidade(token, ignore = []) { //Vulnerabilidade id
    return this.httpClient
      .get<UsuarioUnidade[]>(
        environment.wsUrl + "usuario/listaUsuariosUnidade/" + token,
        {
          headers: { ignore: ignore },
        }
      )
      .pipe(map((r) => r.map((u) => new UsuarioUnidade(u))))
      .toPromise();
  }

  deletarUsuarioUnidade(
    usuario: UsuarioUnidade,
    justificativa: string,
    ignore = []
  ) { //Vulnerabilidade id
    return this.httpClient
      .post(environment.wsUrl + "usuario/deletarUsuarioUnidade", usuario, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  getUsuario(id, ignore = []) { //Vulnerabilidade id
    return this.httpClient
      .get<UsuarioUnidade>(
        environment.wsUrl + "usuario/getUsuarioPermissao/" + id,
        {
          headers: { ignore: ignore },
        }
      )
      .pipe(map((u) => new UsuarioUnidade(u)))
      .toPromise();
  }

  getUsuarioByLogin(login, ignore = []) {
    return this.httpClient
      .get<UsuarioUnidade>(
        environment.wsUrl + "usuario/getUsuarioByLogin/" + login,
        {
          headers: { ignore: ignore },
        }
      )
      .pipe(map((u) => new UsuarioUnidade(u)))
      .toPromise();
  }

  editarUsuario(data, justificativa, ignore = []) { //Vulnerabilidade id
    return this.httpClient
      .post(environment.wsUrl + "usuario/atualizarUsuario", data, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  adicionarUsuario(data, justificativa, ignore = []) { //Vulnerabilidade id
    return this.httpClient
      .post(environment.wsUrl + "usuario/criarUsuario", data, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  editarUsuarioUnidade(data, justificativa, ignore = []) { //Vulnerabilidade id
    return this.httpClient
      .post(environment.wsUrl + "usuario/atualizarUsuarioUnidade", data, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  adicionarUsuarioUnidade(data, justificativa, ignore = []) { //Vulnerabilidade id
    return this.httpClient
      .post(environment.wsUrl + "usuario/criarUsuarioUnidade", data, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  alterarSenhaUsuario(data, justificativa, ignore = []) {
    return this.httpClient
      .post(environment.wsUrl + "usuario/atualizarSenhaUsuario", data, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  alterarStatusUsuario(data: UsuarioUnidade, justificativa, ignore = []) { //bloquear
    return this.httpClient
      .post(environment.wsUrl + "usuario/atualizarStatusUsuario", data, {
        headers: {
          ignore: ignore,
          justificativa: justificativa,
        },
      })
      .toPromise();
  }

  listarUsuario() {
    return this.httpClient
      .get<any>(environment.wsUrl + "usuario/listaTodosUsuarios")
      .toPromise();
  }

  getUserConfigs() {
    return this.httpClient
      .get<UserConfigs>(environment.wsUrl + "getUserConfigs")
      .toPromise();
  }

  setUserConfigsLogin(userConfigs: UserConfigs): void { //bloquear
    this.httpClient
      .post(environment.wsUrl + "usuario/setUserConfigsLogin", userConfigs)
      .toPromise();
  }

  confirmarEmail(token: string): Promise<any> {
    return this.httpClient
      .get(environment.wsUrl + "usuario/confirmar-email", {
        params: { token }
      })
      .toPromise();
  }

  autorizarDispositivo(token: string): Promise<any> {
    return this.httpClient
      .get(environment.wsUrl + "usuario/autorizar-dispositivo", {
        params: { token }
      })
      .toPromise();
  }
}
